import * as React from "react";
import SUBSCRIPTION_STATUS from "../enums/SubscriptionStatus";
import { getNextDateFromDay } from "../utils/DateTimeUtils";

const AlreadySubscribed = ({ plans }) => {
  const restaurant = JSON.parse(localStorage.getItem("restaurant"));
  const activeSubscription = restaurant?.subscriptions?.find(
    (s) => s.status === SUBSCRIPTION_STATUS.ACTIVE
  );
  const billingDay =
    activeSubscription?.mpSubscribeResult?.auto_recurring?.billing_day;
  const value = plans.filter(
    (p) => p._id === activeSubscription?.subscriptionPlan
  )[0]?.price;

  return (
    <div>
      <p className="text-yellow-500">¡Ya estás suscripto!</p>
      <p>Valor mensual: ${value}</p>
      <p>Fecha de próximo cobro: {getNextDateFromDay(billingDay)}</p>
      <p>
        Por cualquier duda o consulta relacionada a la suscripción, escribinos a{" "}
        <a href="mailto:soporte@morfy.app">soporte@morfy.app</a>
      </p>
    </div>
  );
};

export default AlreadySubscribed;
